import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 下单
const Login = r =>
  require.ensure([], () => r(require('../pages/login')), 'login')
const Home = r => require.ensure([], () => r(require('../pages/home')), 'home')
const Customer = r =>
  require.ensure([], () => r(require('../pages/customer')), 'customer')
const SecretCreate = r =>
  require.ensure([], () => r(require('../pages/secret/create')), 'secretCreate')
const ContactPreview = r =>
  require.ensure([], () => r(require('../pages/contact')), 'contactPreview')
const TemplatePreview = r =>
  require.ensure([], () => r(require('../pages/template')), 'templatePreview')
const PrinterUserList = r =>
  require.ensure(
    [],
    () => r(require('../pages/printer/user/list')),
    'printerUserList'
  )
const DeviceUserList = r =>
  require.ensure(
    [],
    () => r(require('../pages/printer/user/device')),
    'deviceUserList'
  )
const PrinterUserCreate = r =>
  require.ensure(
    [],
    () => r(require('../pages/printer/user/create')),
    'printerUserCreate'
  )
const ActivityConfig = r =>
  require.ensure(
    [],
    () => r(require('../pages/activity/config')),
    'activityConfig'
  )
const SchoolOrderList = r =>
  require.ensure(
    [],
    () => r(require('../pages/school/list')),
    'schoolOrderList'
  )
const LabelsConfig = r =>
  require.ensure([], () => r(require('../pages/labels/config')), 'labelsConfig')
const LongQuestionConfig = r =>
  require.ensure(
    [],
    () => r(require('../pages/longQuestion/list')),
    'longQuestionConfig'
  )
const AddLongQuestionConfig = r =>
  require.ensure(
    [],
    () => r(require('../pages/longQuestion/addQuestion')),
    'addLongQuestionConfig'
  )
const Download = r =>
  require.ensure([], () => r(require('../pages/download')), 'download')
const MarketManage = r =>
  require.ensure([], () => r(require('../pages/MarketManage')), 'MarketManage')
const NewsManageIndex = r =>
  require.ensure([], () => r(require('../pages/news')), 'newsManageIndex')
const AddNewsManageConfig = r =>
  require.ensure(
    [],
    () => r(require('../pages/news/addNews')),
    'addNewsManageConfig'
  )
const AttrackNewUserManage = r =>
  require.ensure(
    [],
    () => r(require('../pages/attrackNewUserManage')),
    'AttrackNewUserManage'
  )
const FakeNewManage = r =>
  require.ensure(
    [],
    () => r(require('../pages/FakeNewManage')),
    'FakeNewManage'
  )
const FollowUpManage = r =>
  require.ensure(
    [],
    () => r(require('../pages/FollowUpManage')),
    'FollowUpManage'
  )

const CommonDownload = r =>
  require.ensure(
    [],
    () => r(require('../pages/CommonDownload')),
    'CommonDownload'
  )
const CourierTaskChange = r =>
  require.ensure(
    [],
    () => r(require('../pages/CourierTaskChange/index.vue')),
    'CourierTaskChange'
  )
const CustomerCenterManage = r =>
  require.ensure(
    [],
    () => r(require('../pages/customerCenterManage/list.vue')),
    'customerCenterManageList'
  )
// const TikTokOrderRefundManage = r =>
//   require.ensure(
//     [],
//     () => r(require('../pages/tikTokOrderListManage/refund.vue')),
//     'tikTokOrderRefundManage'
//   )
const TikTokOrderQueryManage = r =>
  require.ensure(
    [],
    () => r(require('../pages/tikTokOrderListManage/query.vue')),
    'tikTokOrderQueryManage'
  )
const QwCustomerGroupManageBasic = r =>
  require.ensure(
    [],
    () => r(require('../pages/qwCustomerGroupManage/basic.vue')),
    'qwCustomerGroupManageBase'
  )
const QwCustomerGroupManageCreate = r =>
  require.ensure(
    [],
    () => r(require('../pages/qwCustomerGroupManage/create.vue')),
    'qwCustomerGroupManageCreate'
  )
const QwCustomerGroupManageMessage = r =>
  require.ensure(
    [],
    () => r(require('../pages/qwCustomerGroupManage/message.vue')),
    'qwCustomerGroupManageMessage'
  )
const QwCustomerGroupManageWelcome = r =>
  require.ensure(
    [],
    () => r(require('../pages/qwCustomerGroupManage/welcome.vue')),
    'qwCustomerGroupManageWelcome'
  )
const CouponConfigManage = r =>
  require.ensure(
    [],
    () => r(require('../pages/couponConfigManage/index.vue')),
    'couponConfigManage'
  )
const CourierMarketManage = r =>
  require.ensure(
    [],
    () => r(require('../pages/courierMarketManage/index.vue')),
    'CourierMarketManage'
  )
const CourierMarketDiscount = r =>
  require.ensure(
    [],
    () => r(require('../pages/courierMarketManage/discount.vue')),
    'CourierMarketDiscount'
  )
const CourierMarketCalendar = r =>
  require.ensure(
    [],
    () => r(require('../pages/courierMarketManage/calendar.vue')),
    'CourierMarketCalendar'
  )
const CourierMarketTarget = r =>
  require.ensure(
    [],
    () => r(require('../pages/courierMarketManage/target.vue')),
    'CourierMarketTarget'
  )

const jMeMessageManageLabel = r =>
  require.ensure(
    [],
    () => r(require('../pages/jMeMessageManage/labelManage.vue')),
    'jMeMessageManageLabel'
  )
const jMeMessageManageStaff = r =>
  require.ensure(
    [],
    () => r(require('../pages/jMeMessageManage/staffManage.vue')),
    'jMeMessageManageStaff'
  )
const jMeMessageManageMsgPush = r =>
  require.ensure(
    [],
    () => r(require('../pages/jMeMessageManage/msgPush.vue')),
    'jMeMessageManageMsgPush'
  )
const categoryManageAudit = r =>
  require.ensure(
    [],
    () => r(require('../pages/categoryManage/audit.vue')),
    'categoryManageAudit'
  )
const categoryManageList = r =>
  require.ensure(
    [],
    () => r(require('../pages/categoryManage/list.vue')),
    'categoryManageList'
  )
const investorNoticeManage = r =>
  require.ensure(
    [],
    () => r(require('../pages/investorNoticeManage/index.vue')),
    'investorNoticeManage'
  )
const routes = new VueRouter({
  base: '/wechat/www/view/index.html/',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      name: 'login',
      path: '/login',
      component: Login,
      meta: {
        title: '登录'
      }
    },
    {
      name: 'home',
      path: '/home',
      component: Home,
      children: [
        {
          name: 'customer',
          path: '/customer',
          component: Customer,
          meta: {
            title: '审核记录'
          }
        },
        {
          name: 'secretCreate',
          path: '/secret/create',
          component: SecretCreate,
          meta: {
            title: '生成密钥'
          }
        },
        {
          name: 'contactPreview',
          path: '/contact/preview',
          component: ContactPreview,
          meta: {
            title: '查询联系人'
          }
        },
        {
          name: 'templatePreview',
          path: '/template/preview',
          component: TemplatePreview,
          meta: {
            title: '模版预览'
          }
        },
        {
          name: 'printerUserList',
          path: '/printer/user',
          component: PrinterUserList,
          meta: {
            title: '设备管理-人员列表'
          }
        },
        {
          name: 'deviceUserList',
          path: '/printer/device/:id',
          component: DeviceUserList,
          meta: {
            title: '设备管理-人员列表'
          }
        },
        {
          name: 'printerUserCreate',
          path: '/printer/user/create',
          component: PrinterUserCreate,
          meta: {
            title: '设备管理-新增用户'
          }
        },
        {
          name: 'activityConfig',
          path: '/activity/config',
          component: ActivityConfig,
          meta: {
            title: '活动管理'
          }
        },
        {
          name: 'labelsConfig',
          path: '/labels/config',
          component: LabelsConfig,
          meta: {
            title: '问卷标签'
          }
        },
        {
          name: 'longQuestionConfig',
          path: '/longQuestion/list',
          component: LongQuestionConfig,
          meta: {
            title: '长问卷管理'
          }
        },
        {
          name: 'addLongQuestionConfig',
          path: '/longQuestion/add',
          component: AddLongQuestionConfig,
          meta: {
            title: '长问卷管理'
          }
        },
        {
          name: 'schoolOrderList',
          path: '/school/list',
          component: SchoolOrderList,
          meta: {
            title: '校园寄-订单列表'
          }
        },
        {
          name: 'download',
          path: '/download',
          component: Download,
          meta: {
            title: '客户编码二维码生成'
          }
        },
        {
          name: 'marketManage',
          path: '/marketManage',
          component: MarketManage,
          meta: {
            title: '微营销权限管理'
          }
        },
        {
          name: 'newsManageIndex',
          path: '/news/index',
          component: NewsManageIndex,
          meta: {
            title: '新闻管理'
          }
        },
        {
          name: 'addNews',
          path: '/news/addNews',
          component: AddNewsManageConfig,
          meta: {
            title: '新闻管理'
          }
        },
        {
          name: 'attrackNewUserManage',
          path: '/attrackNewUserManage',
          component: AttrackNewUserManage,
          meta: {
            title: '拉新中奖管理'
          }
        },
        {
          name: 'fakeNewManage',
          path: '/fakeNewManage',
          component: FakeNewManage,
          meta: {
            title: '虚假拉新管理'
          }
        },
        {
          name: 'followUpManage',
          path: '/followUpManage',
          component: FollowUpManage,
          meta: {
            title: '回访明细管理'
          }
        },
        {
          name: 'commonDownload',
          path: '/commonDownload',
          component: CommonDownload,
          meta: {
            title: '通用明细下载'
          }
        },
        {
          name: 'courierTaskChange',
          path: '/courierTaskChange',
          component: CourierTaskChange,
          meta: {
            title: '回访任务移交'
          }
        },
        {
          name: 'customerCenterManageList',
          path: '/CustomerCenterManage/list',
          component: CustomerCenterManage,
          meta: {
            title: '客服中心配置'
          }
        },
        // {
        //   name: 'TikTokOrderRefundManage',
        //   path: '/tikTokOrderListManage/refund',
        //   component: TikTokOrderRefundManage,
        //   meta: {
        //     title: '抖音本地生活-退款管理'
        //   }
        // },
        {
          name: 'TikTokOrderQueryManage',
          path: '/tikTokOrderListManage/query',
          component: TikTokOrderQueryManage,
          meta: {
            title: '抖音本地生活-查单&退款管理'
          }
        },
        {
          name: 'qwCustomerGroupManageBasic',
          path: '/qwCustomerGroupManage/basic',
          component: QwCustomerGroupManageBasic,
          meta: {
            title: '微信群管理-群基础管理'
          }
        },
        {
          name: 'qwCustomerGroupManageCreate',
          path: '/qwCustomerGroupManage/create',
          component: QwCustomerGroupManageCreate,
          meta: {
            title: '微信群管理-建群管理'
          }
        },
        {
          name: 'qwCustomerGroupManageMessage',
          path: '/qwCustomerGroupManage/message',
          component: QwCustomerGroupManageMessage,
          meta: {
            title: '微信群管理-群基础管理'
          }
        },
        {
          name: 'qwCustomerGroupManageWelcome',
          path: '/qwCustomerGroupManage/welcome',
          component: QwCustomerGroupManageWelcome,
          meta: {
            title: '微信群管理-欢迎语管理'
          }
        },
        {
          name: 'couponConfigManage',
          path: '/couponConfigManage',
          component: CouponConfigManage,
          meta: {
            title: '优惠券设置'
          }
        },
        {
          name: 'CourierMarketManage',
          path: '/courierMarketManage/index',
          component: CourierMarketManage,
          meta: {
            title: '底价配置'
          }
        },
        {
          name: 'CourierMarketDiscount',
          path: '/courierMarketManage/discount',
          component: CourierMarketDiscount,
          meta: {
            title: '折扣配置'
          }
        },
        {
          name: 'CourierMarketCalendar',
          path: '/courierMarketManage/calendar',
          component: CourierMarketCalendar,
          meta: {
            title: '日历系数配置'
          }
        },
        {
          name: 'CourierMarketTarget',
          path: '/courierMarketManage/target',
          component: CourierMarketTarget,
          meta: {
            title: '月度目标配置'
          }
        },
        {
          name: 'jMeMessageManageLabel',
          path: '/jMeMessageManage/labelManage',
          component: jMeMessageManageLabel,
          meta: {
            title: '京ME应用管理-标签管理'
          }
        },
        {
          name: 'jMeMessageManageStaff',
          path: '/jMeMessageManage/staffManage',
          component: jMeMessageManageStaff,
          meta: {
            title: '京ME应用管理-建群管理'
          }
        },
        {
          name: 'jMeMessageManageMsgPush',
          path: '/jMeMessageManage/msgPush',
          component: jMeMessageManageMsgPush,
          meta: {
            title: '京ME应用管理-群基础管理'
          }
        },
        {
          name: 'categoryManageAudit',
          path: '/categoryManage/audit',
          component: categoryManageAudit,
          meta: {
            title: '品类管理-品名审核'
          }
        },
        {
          name: 'categoryManageList',
          path: '/categoryManage/list',
          component: categoryManageList,
          meta: {
            title: '品类管理-品名管理'
          }
        },
        {
          name: 'investorNoticeManage',
          path: '/investorNoticeManage/index',
          component: investorNoticeManage,
          meta: {
            title: '公司公告管理'
          }
        }
      ]
    }
  ]
})

routes.beforeEach((to, from, next) => {
  next()
})

routes.afterEach((to, from) => {
  document.title = to.meta.title
})

export default routes



// WEBPACK FOOTER //
// ./src/router/index.js